import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/goodsManage',
  name: 'GoodsManage',
  identify: 'goodsManage',
  component: LAYOUT,
  redirect: '/goodsManage/goodsList',
  meta: {
    icon: 'iconoir:commodity',
    title: '商品管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'goodsList',
      name: 'GoodsList',
      component: () => import('@/views/goodsManage/goodsList/index.vue'),
      identify: 'goodsList',
      meta: {
        title: '商品信息',
        affix: true,
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'goodsPackage',
      name: 'GoodsPackage',
      identify: 'goodsPackage',
      component: () => import('@/views/goodsManage/goodsPackage/index.vue'),
      meta: {
        title: '商品套装',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'goodsPackage/add',
      name: 'GoodsPackageAdd',
      component: () => import('@/views/goodsManage/goodsPackage/Add.vue'),
      identify: 'goodsPackage',
      meta: {
        title: '新建套餐',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/goodsManage/goodsPackage',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'goodsOwn',
      name: 'GoodsOwn',
      identify: 'goodsOwn',
      component: () => import('@/views/goodsManage/goodsOwn/index.vue'),
      meta: {
        title: '自有商品管理',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'goodsOwn/:pageType/:orderNum?',
      name: 'GoodsOwnDetail',
      component: () => import('@/views/goodsManage/goodsOwn/add.vue'),
      identify: 'goodsOwn',
      meta: {
        title: '商品详情',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/goodsManage/goodsOwn',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
